module.exports = __webpack_public_path__ + "img/catering.899e59ae.png";